module.exports = __webpack_public_path__ + "img/default-profile-picture.b75512fd.svg";